var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLokWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 384C280 397.3 269.3 408 256 408C242.7 408 232 397.3 232 384V320C232 306.7 242.7 296 256 296C269.3 296 280 306.7 280 320V384ZM256 0C326.7 0 384 57.31 384 128V192H416C451.3 192 480 220.7 480 256V448C480 483.3 451.3 512 416 512H96C60.65 512 32 483.3 32 448V256C32 220.7 60.65 192 96 192H128V128C128 57.31 185.3 0 256 0ZM256 48C211.8 48 176 83.82 176 128V192H336V128C336 83.82 300.2 48 256 48ZM96 240C87.16 240 80 247.2 80 256V448C80 456.8 87.16 464 96 464H416C424.8 464 432 456.8 432 448V256C432 247.2 424.8 240 416 240H96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLokWhite);
export default __webpack_public_path__ + "static/media/loсk-white.65a5ebfbe0326e6c122c41bfcc5fa48c.svg";
export { ForwardRef as ReactComponent };